export default {
  state: {
    entities: [],
    selectedEntity: [],
    sublists: [],
    entitiesPagination: {
      entities: {},
      single: {},
    },
  },
  getters: {
    "nlp/entities/query": (state) => (query) => {
      const fallback = [];
      if (!state.entities || !state.entities.length) return fallback;
      const result = state.entities.filter((intent) =>
        intent.name.toLowerCase().includes(query.toLowerCase())
      );
      return result && result.length ? result.reverse() : fallback;
    },
  },
  mutations: {
    "nlp/entities/add": function (state, data) {
      state.entities.splice(0, 0, data);
    },
    "nlp/entities/set": function (state, data) {
      state.entities = data;
    },
    "nlp/entities/select": function (state, data) {
      state.selectedEntity = data;
    },
    "nlp/entities/sublists/set": function (state, data) {
      state.sublists = data;
    },
    "nlp/entities/sublists/push": function (state, data) {
      state.sublists.push = data;
    },
    "nlp/entities/synonyms/set": function (state, data) {
      state.sublists = state.sublists.map((sublist) => {
        if (sublist.id === data.sublist) {
          return { ...sublist, synonyms: data.synonyms };
        }
        return sublist;
      });
    },
    "nlp/entities/list/pagination/set": function (state, data) {
      state.entitiesPagination.entities = data;
    },
    "nlp/entities/single/pagination/set": function (state, data) {
      state.entitiesPagination.single = data;
    },
  },
  actions: {
    "nlp/entities/get": async function ({ commit, dispatch, state }, payload) {
      try {
        const params = _.omit(payload || {}, ["hideLoading"]);
        const hideLoading = payload && payload.hideLoading;
        if (!hideLoading) {
          dispatch("setLoader", true);
        }
        //dispatch('setLoader', true)
        //console.log(`${state.selectedApp.id}`)
        const { data } = await this._vm.$http_nlp({
          url: `/apps/${state.selectedApp.id}/entities`,
          params,
          method: "get",
        });
        if (!hideLoading) {
          dispatch("setLoader", false);
        }
        const { result } = data.data;
        commit("nlp/entities/set", result);
        commit(
          "nlp/entities/list/pagination/set",
          _.omit(data.data, ["result"])
        );
        return result;
      } catch (err) {
        dispatch("setLoader", false);
        commit("nlp/entities/set", []);
        throw err;
      }
    },
    "nlp/entities/get/single": async function ({ state, commit }, id) {
      try {
        const { data } = await this._vm.$http_nlp.get(
          `/apps/${state.selectedApp.id}/entities/${id}`
        );
        commit("nlp/entities/select", data.data);
        return data.data;
      } catch (err) {
        throw err;
        return false;
      }
    },
    "nlp/entities/get/single/sublists": async function (
      { state, commit, dispatch },
      payload
    ) {
      try {
        const params = _.omit(payload || {}, ["hideLoading", "id"]);
        const hideLoading = payload && payload.hideLoading;
        const id = payload && payload.id ? payload.id : null;
        if (!hideLoading) {
          dispatch("setLoader", true);
        }
        const { data } = await this._vm.$http_nlp.get(
          `/apps/${state.selectedApp.id}/entity_sublists`,
          { params: { "filter[entity]": state.selectedEntity.id, ...params } }
        );
        if (!hideLoading) {
          dispatch("setLoader", false);
        }
        const result = data.data.result;
        commit("nlp/entities/sublists/set", result);
        commit(
          "nlp/entities/list/pagination/set",
          _.omit(data.data, ["result"])
        );
        return result;
      } catch (err) {
        dispatch("setLoader", false);
        throw err;
        return err;
      }
    },
    "nlp/entities/single/sublist/add": async function (
      { state, commit, dispatch },
      payload
    ) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/entity_sublists`,
          { name: payload.name, entity: state.selectedEntity.id }
        );
        const result = { ...data.data, synonyms: [] };
        let i;
        let temp;
        for (i = 0; i < payload.synonyms.length; i += 1) {
          temp = await this._vm.$http_nlp.post(
            `/apps/${state.selectedApp.id}/entity_synonyms`,
            { entity_sublist: result.id, name: payload.synonyms[i] }
          );
          result.synonyms.push(temp.data);
        }
        dispatch("setLoader", false);
        commit("nlp/entities/sublists/push", result);
        return result;
      } catch (err) {
        dispatch("setLoader", false);
        throw err;
        return err;
      }
    },
    "nlp/entities/single/sublist/delete": async function (
      { state, commit, dispatch },
      id
    ) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/entity_sublists/${id}`
        );
        dispatch("setLoader", false);
        return true;
      } catch (err) {
        dispatch("setLoader", false);
        throw err;
        return err;
      }
    },
    "nlp/entities/get/single/synonyms": async function (
      { state, commit, dispatch },
      id
    ) {
      try {
        if (!id || !state.selectedEntity) return;
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_nlp.get(
          `/apps/${state.selectedApp.id}/entity_synonyms`,
          { params: { "filter[entity_sublist]": id } }
        );
        dispatch("setLoader", false);
        commit("nlp/entities/synonyms/set", {
          synonyms: data.data,
          sublist: id,
        });
        return data.data.result;
      } catch (err) {
        dispatch("setLoader", false);
        throw err;
        return err;
      }
    },
    "nlp/entities/add": async function ({ commit, dispatch, state }, payload) {
      try {
        const pack = payload;
        const { data } = await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/entities`,
          pack
        );
        dispatch("nlp/entities/get");
        return data;
      } catch (err) {
        throw err;
        return err;
      }
    },
    "nlp/entities/update": async function (
      { commit, dispatch, state },
      payload
    ) {
      try {
        const picks = ["name", "type"];
        if (payload.type === "regex") {
          picks.push("regex");
        }
        const { data } = await this._vm.$http_nlp.put(
          `/apps/${state.selectedApp.id}/entities/${payload.id}`,
          this._vm.$_.pick(payload, picks)
        );
        dispatch("nlp/entities/get");
        return data;
      } catch (err) {
        throw err;
      }
    },
    "nlp/entities/single/sync": async function (
      { commit, dispatch, state },
      id
    ) {
      try {
        const { data } = await this._vm.$http_nlp.put(
          `/apps/${state.selectedApp.id}/entities/${id}/sync`
        );
        dispatch("nlp/entities/get");
        return data;
      } catch (err) {
        throw err;
      }
    },
    "nlp/entities/delete": async function ({ state }, id) {
      try {
        await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/entities/${id}`
        );
        return true;
      } catch (err) {
        throw err;
        return false;
      }
    },
    "nlp/entities/delete/single": async function ({ dispatch, state }, id) {
      try {
        await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/entities/${id}`
        );
        dispatch("nlp/entities/get");
        return true;
      } catch (err) {
        throw err;
        return false;
      }
    },
    "nlp/entities/delete/multiple": async function (
      { dispatch, state },
      payload
    ) {
      try {
        dispatch("setLoader", true);
        let i;
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch("nlp/entities/delete", payload[i].id);
            if (index === payload.length - 1) {
              const res = await dispatch("nlp/entities/get");
              return res;
            }
          } catch (err) {
            dispatch("setLoader", false);
            throw err;
            return false;
          }
        }
      } catch (err) {
        throw err;
      }
    },
    "nlp/entities/set": function ({ commit }, data) {
      commit("nlp/entities/set", result);
      return result;
    },
    "nlp/entities/select": function ({ commit }, data) {
      commit("nlp/entities/select", data);
      return data;
    },
    "nlp/entities/uploadSynonyms": async function (
      { commit, dispatch, state },
      payload
    ) {
      try {
        const pack = payload;
        // if(!payload.app) {
        //   pack.app = state.selectedApp.id
        // }
        const { data } = await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/entity_synonyms/upload`,
          pack
        );
        dispatch("nlp/entities/get/single/synonyms", pack.entity_sublist);
        return data;
      } catch (err) {
        throw new Error(err);
      }
    },
  },
};
